module.exports = __webpack_public_path__ + "img/Thailand-2-hover.1a929288.jpg";